<template>
    <data-dialog
        :dialog-title="sqDlgTitle"
        :closeOnClickModal = 'false'
        :is-visible="sqdialog.formVisible"
        ref="sqDialog"
        @dgVerifyDeal="dgVerifyDeal('sqDialog','sqdioLogForm')"
        @dgCancelDeal='cancel'
        @dgConfirmDeal="save('sqdioLogForm')"
    >
      <div slot="dialogFrom">
        <el-form :model="sqdialog" ref="sqdioLogForm" :rules="rules" label-width="80px" label-position="top" class="commonForm">
            <el-row>
                <el-col :span="12">
                  <el-form-item label="账号" prop="account" style="width: 70%;">
                    <el-input required  v-model="sqdialog.data.account"  disabled maxlength="30" />
                  </el-form-item>
                </el-col>
                <el-col  :span="12">
                    <el-form-item label="角色"  >
                       <el-select  v-model="sqdialog.defaultSelect" multiple placeholder="请选择角色">
                            <el-option
                                    v-for="item in sqdialog.jsdata"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="是否巡查用户" prop="xc" style="width: 70%;">
                      <el-radio-group v-model="sqdialog.data.xc">
                        <el-radio :label="true" :value="true">是</el-radio>
                        <el-radio :label="false" :value="false">否</el-radio>
                      </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col  :span="12">
                    <el-form-item label="水库" prop="defaultSk" >
                        <el-select  v-model="sqdialog.defaultSk" multiple placeholder="请选择水库">
                            <el-option
                                    v-for="item in sqdialog.data.resList"
                                    :key="item.rescd"
                                    :label="item.resName"
                                    :value="item.rescd">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="菜单权限">
              <template #label>
                <span>菜单权限</span>
                <span style="color: indianred; font-size: 12px; margin-left: 8px;">(请先选择水库再进行菜单授权)</span>
              </template>
<!--                <el-checkbox v-model="checkAll" @change="handleCheckedTreeNodeAll">全选/全不选</el-checkbox>-->
<!--                <el-tree class="tree-border" :data="sqdialog.data.list"  node-key="id"-->
<!--                         :default-checked-keys="sqdialog.defaultTree" ref="tree"-->
<!--                        show-checkbox :props="defaultProps">-->
<!--                </el-tree>-->
              <!-- 权限 -->
              <div style="max-height: 50vh">
                <div class="qxAll">
                  <el-checkbox v-model="checkAll" @change="handleCheckedTreeNodeAll()">所有权限</el-checkbox>
                </div>
                <div>
                  <div v-for="(item,index) in sqdialog.data.list" :key="index">
                    <div class="qx">
                      <!-- 左侧父节点 -->
                      <div>
                        <div v-if="item.leaf" class="qxF">
                          <el-checkbox v-model="item.hasCheck"  style="height: 40px;line-height: 40px;">
                            <span>{{ item.label }}</span>
                          </el-checkbox>
                        </div>
                        <div v-else style="width: 120px;padding-left: 10px;">
                          <el-checkbox v-model="item.hasCheck" :indeterminate="item.isIndeterminate"  @change="fjdChange(item)" class="check">
                            <span>{{ item.label }}</span>
                          </el-checkbox>
                        </div>
                      </div>
                      <!-- 右侧子节点 -->
                      <div>
                        <div v-for="c in item.children" :key="c.nodeId+'1'" class="qxZ">
                          <el-checkbox v-model="c.hasCheck" @change="zjdChange(c,item)" :indeterminate="c.isIndeterminate" class="check">
                            <span>{{ c.label }}</span>
                          </el-checkbox>
                        </div>
                      </div>
                      <div style="width: 100%">
                        <div v-for="c in item.children" :key="c.nodeId+'1'" >
                            <el-row v-if="c.children.length > 0" >
                                <el-col :span="6" v-for="(x,index) in c.children" :key="x.nodeId+'2'" class="qxS">
                                    <el-checkbox v-model="c.children[index].hasCheck" @change="sjdChange(c.children[index],c,item)"  class="check">
                                        <span>{{ x.label }}</span>
                                    </el-checkbox>
                                </el-col>
                            </el-row>
                            <div v-else>
                              <div style="height: 40px;border-bottom: 2px solid #f0f5fd;border-left: 2px solid #f0f5fd">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>
        </el-form>
      </div>
    </data-dialog>
</template>

<script>
    import md5 from 'js-md5'
    import DataDialog from "@/components/tableGather/dataDialog.vue";
    export default {
        name: "userSqOpen",
      components: {DataDialog},
        data(){
            return{
              defaultChoose:this.sqdialog.defaultSelect,
              sqDlgTitle:"用户授权",
              //授权
              checkAll: false,
              allCheck: true,
              hasCheck: true,
              grandHasCheck: true,
              isIndeterminate: true,
              defaultProps: {
                children: "children",
                label: "label"
              },
              resetMmState:true,
              rules: {
                defaultSk:[ {  required: true, message: '请选择水库', trigger: 'change'}],
                // account: [
                //   {required: true, message: '请输入账号', trigger: 'blur'},
                //   {min: 4, max: 30, message: '长度在 4 到 30 个字符', trigger: 'blur'}
                // ],
                //   mm: [
                //   {min: 6, max: 30, message: '长度在 6 到 30 个字符', trigger: 'change'}
                // ],

              },
            }
        },
      methods:{
          dgVerifyDeal(dgRef, frRef) {
            this.$refs[frRef].validate((valid) => {
              if (valid) {
                this.$refs[dgRef].isShowPop(true);
              } else {
                this.$refs[dgRef].isShowPop(false);
              }
            });
          },
          cancel(){
            this.$emit("reset")
            this.sqdialog.formVisible = false
            //重置表单值
            this.$refs['sqdioLogForm'].resetFields();
            this.resetMmState=true
            this.checkAll= false
          },
          // 树权限（全选/全不选）
          handleCheckedTreeNodeAll(value) {
              //this.$refs.tree.setCheckedNodes(value ? this.sqdialog.data.list: []);
            if (this.checkAll) {
              for (let i = 0; i < this.sqdialog.data.list.length; i++) {
                this.sqdialog.data.list[i].hasCheck = true;
                if (!this.sqdialog.data.list[i].leaf) {
                  this.sqdialog.data.list[i].allCheck = false;
                    this.sqdialog.data.list[i].isIndeterminate = false;
                  for (let a = 0; a < this.sqdialog.data.list[i].children.length; a++) {
                    this.sqdialog.data.list[i].children[a].hasCheck = true;
                      this.sqdialog.data.list[i].children[a].isIndeterminate = false;
                    for(let j = 0 ;j<this.sqdialog.data.list[i].children[a].children.length;j++){
                      this.sqdialog.data.list[i].children[a].children[j].hasCheck = true;
                    }
                  }
                }
              }
            }else{
              for (let i = 0; i < this.sqdialog.data.list.length; i++) {
                this.sqdialog.data.list[i].hasCheck = false;
                if (!this.sqdialog.data.list[i].leaf) {
                  this.sqdialog.data.list[i].allCheck = false;
                    this.sqdialog.data.list[i].isIndeterminate = false;
                  for (let a = 0; a < this.sqdialog.data.list[i].children.length; a++) {
                    this.sqdialog.data.list[i].children[a].hasCheck = false;
                      this.sqdialog.data.list[i].children[a].isIndeterminate = false;
                    for(let j = 0 ;j<this.sqdialog.data.list[i].children[a].children.length;j++){
                      this.sqdialog.data.list[i].children[a].children[j].hasCheck = false;
                    }
                  }
                }
              }
            }
          },
        // 父节点选择
        fjdChange(item){
            item.isIndeterminate = false;
          if (item.hasCheck) {
            item.allCheck = false;
            for (let i = 0; i < item.children.length; i++) {
              item.children[i].hasCheck = true;
              this.hasCheck = true;
              for(let j =0; j< item.children[i].children.length;j++){
                item.children[i].children[j].hasCheck = true;
              }
            }

          }else{
            item.allCheck = false;
            for (let i = 0; i < item.children.length; i++) {
              item.children[i].hasCheck = false;
              for(let j =0; j< item.children[i].children.length;j++){
                item.children[i].children[j].hasCheck = false;
              }
            }
          }
        },
        // 子节点选择
        zjdChange(val,item){
              //子组件与父组件联动
            let checklenth = 0
            for(let i of item.children){
                if(i.hasCheck){
                    checklenth++
                }
            }
            item.hasCheck = checklenth === item.children.length
            item.isIndeterminate = checklenth > 0 && checklenth < item.children.length;
            //子组件与孙组件联动
            for(let i of val.children){
                i.hasCheck = val.hasCheck
            }
            val.isIndeterminate = false
        },
        // 孙节点选择
        sjdChange(val,c,item){
              //特殊情况（如有三级权限必有查询查询）
           /* if(val.label !== '查询'){
                for(let i of c.children){
                    if(i.label === '查询' && val.hasCheck === true){
                        i.hasCheck = true
                    }
                }
            }*/
            //孙节点与子组件联动
            let checklenth = 0
            for(let i of c.children){
                if(i.hasCheck){
                    checklenth++
                }
            }
            c.hasCheck = checklenth === c.children.length
            c.isIndeterminate = checklenth > 0 && checklenth < c.children.length;
            //孙节点与父组件联动
            let sunlenth = 0
            let sunchecklenth = 0
            for(let i of item.children){
                sunlenth++
                if(i.hasCheck){
                    sunchecklenth++
                }
                for(let ii of i.children){
                    sunlenth++
                    if(ii.hasCheck){
                        sunchecklenth++
                    }
                }
            }
            item.hasCheck = sunlenth === sunchecklenth
            item.isIndeterminate = sunchecklenth > 0 && sunchecklenth < sunlenth;
        },
          save(event){
            this.$refs[event].validate((valid) => {
              if (valid) {
                  // let zi = this.$refs.tree.getCheckedKeys()//返回选中子节点的key
                  // let fu =this.$refs.tree.getHalfCheckedKeys()//返回选中子节点的父节点的key
                  // let qxcList = zi.concat(fu)
                let xz = [];
                for (let i = 0; i < this.sqdialog.data.list.length; i++) {
                  const fu = this.sqdialog.data.list[i];
                  if (fu.leaf) {
                    if (fu.hasCheck || fu.isIndeterminate) {
                      xz.push(fu.authbit);
                    }
                  }else{
                    if (fu.hasCheck || fu.isIndeterminate) {
                      xz.push(fu.authbit);
                    }
                    for (let a = 0; a < fu.children.length; a++) {
                      const zi = fu.children[a];
                      if (zi.hasCheck || zi.isIndeterminate) {
                        xz.push(zi.authbit);
                      }
                      for(let b = 0 ; b < zi.children.length;b++){
                        const sun = zi.children[b];
                        if (sun.hasCheck) {
                          xz.push(sun.authbit);
                        }
                      }
                    }
                  }
                }

                const data = {
                  id:this.sqdialog.data.id,
                  authstrList:xz,
                  roleIds:this.sqdialog.defaultSelect,
                  rescdList:this.sqdialog.defaultSk,
                  xc:this.sqdialog.data.xc
                }
                this.request.post("/rm-suser/v1/authorization", data).then(res => {
                  if (res.ok) {
                    this.$message.success("授权用户完成！")
                  }else{
                      this.$message.error(res.error)
                  }
                  this.cancel();
                })
              } else {
                return false;
              }
            });
          },
        },
      props:['sqdialog'],
    }
</script>
<style scoped>
.commonForm {
    padding: 20px;
  /*padding-top: 4vh;
  padding-left: 6vw;*/
}
.qxAll{
  background-color: #f2f3f5;
  height: 40px;
  line-height: 40px;
  padding-left: 10px;
}
.qx{
  display: flex;
  justify-content: flex-start;
  align-items:center;
  border: 2px solid #f0f5fd;
  margin-bottom: -2px;
}
.qxF{
  width: 120px;
  /*border-right: 2px solid #f0f5fd;*/
  padding-left: 10px;
}

.qxZ{
  width: 120px;
  border-left: 2px solid #f0f5fd;
  border-right: 2px solid #f0f5fd;
  border-bottom: 2px solid #f0f5fd;
  padding-left: 20px;
}
.qxS{
    //width: 25%;
  padding:0px 20px;
    border-left: 2px solid #f0f5fd;
    border-right: 2px solid #f0f5fd;
    border-bottom: 2px solid #f0f5fd;
}

.qxM{
  padding-left: 20px;
  border: 2px solid #f0f5fd;
    width: 50px;
}

.qxN{
  padding-left: 20px;
  border-right: 2px solid #f0f5fd;
}

/deep/ .el-select{
    width: 70%;
}
</style>
